import { useLanguage } from '../context/LanguageContext';
import { X, Shield } from 'lucide-react';

const PrivacyModal = ({ isOpen, onClose }) => {
  const { language } = useLanguage();

  if (!isOpen) return null;

  const content = language === 'he' ? {
    title: 'מדיניות פרטיות',
    subtitle: 'בהתאם לחוק הגנת הפרטיות, התשמ"א-1981 (תיקון 13)',
    sections: [
      {
        heading: '1. כללי',
        text: 'מדיניות פרטיות זו מתארת את האופן שבו Eran MH Coaching ("אנחנו", "האתר") אוסף, משתמש ומגן על מידע אישי הנמסר על ידך ("המשתמש") באתר זה. מדיניות זו מעודכנת בהתאם לתיקון 13 לחוק הגנת הפרטיות, התשמ"א-1981, שנכנס לתוקף ב-14 באוגוסט 2025.',
      },
      {
        heading: '2. מידע שאנו אוספים',
        text: 'במסגרת שימושך באתר, אנו עשויים לאסוף את המידע הבא:\n• שם מלא\n• מספר טלפון\n• מדינת מגורים\n• זמן מועדף ליצירת קשר (בוקר/צהריים/ערב)\n• כתובת דוא"ל (אם נמסרה)\n• תוכן הודעה חופשית (אם נמסר)\n• נתוני שימוש באתר באמצעות עוגיות (cookies)',
      },
      {
        heading: '3. מטרות איסוף המידע',
        text: 'המידע נאסף אך ורק למטרות הבאות:\n• יצירת קשר חוזר בהתאם לפנייתך\n• מתן מידע על שירותי אימון אישי\n• תיאום פגישות ושיחות היכרות\n• שיפור חוויית המשתמש באתר\n\nלא נעשה שימוש במידע למטרות שיווקיות ללא הסכמתך המפורשת.',
      },
      {
        heading: '4. בסיס חוקי לעיבוד המידע',
        text: 'עיבוד המידע האישי מתבצע על בסיס הסכמתך המפורשת, הניתנת בעת מילוי טופס יצירת הקשר ואישור מדיניות פרטיות זו. באפשרותך לחזור בך מהסכמתך בכל עת.',
      },
      {
        heading: '5. שמירה ואבטחת מידע',
        text: 'המידע נשמר במערכות מאובטחות הכוללות:\n• הצפנת תעבורה באמצעות SSL/TLS\n• הגבלת גישה למורשים בלבד\n• אחסון מאובטח בשרתי ענן\n\nהמידע נשמר כל עוד הוא נדרש למטרות שלשמן נאסף, או עד לבקשת מחיקה מצדך.',
      },
      {
        heading: '6. העברת מידע לצד שלישי',
        text: 'איננו מעבירים, מוכרים או משכירים מידע אישי לצדדים שלישיים, למעט במקרים הבאים:\n• כאשר נדרש על פי דין\n• לצורך אספקת השירותים (למשל, שירותי דוא"ל טכניים)\n\nבכל מקרה, העברת מידע תתבצע בכפוף לאמצעי הגנה מתאימים.',
      },
      {
        heading: '7. זכויותיך על פי החוק',
        text: 'בהתאם לתיקון 13, עומדות לך הזכויות הבאות:\n• הזכות לעיין במידע האישי שנשמר אודותיך\n• הזכות לתקן מידע שגוי או לא מעודכן\n• הזכות לבקש מחיקת המידע האישי שלך\n• הזכות להגביל את עיבוד המידע\n• הזכות לחזור בך מהסכמה שניתנה\n\nלמימוש זכויותיך, פנה אלינו בדוא"ל: eran.mazor86@gmail.com. נשיב לפנייתך תוך 30 ימים.',
      },
      {
        heading: '8. שימוש בעוגיות (Cookies)',
        text: 'האתר משתמש בעוגיות לצורך:\n• שמירת העדפות שפה\n• שיפור חוויית הגלישה\n• ניתוח סטטיסטי של השימוש באתר\n\nבאפשרותך לנהל את העדפות העוגיות דרך באנר העוגיות או דרך הגדרות הדפדפן שלך.',
      },
      {
        heading: '9. רישום מאגר מידע',
        text: 'בהתאם להוראות תיקון 13, האתר אינו נדרש לרישום מאגר מידע, שכן מטרתו העיקרית אינה איסוף מידע למסירה לאחר כדרך עיסוק, ואינו מכיל מידע על למעלה מ-10,000 בני אדם.',
      },
      {
        heading: '10. יצירת קשר',
        text: 'לשאלות, בירורים או מימוש זכויות בנוגע למדיניות פרטיות זו:\nדוא"ל: eran.mazor86@gmail.com\nWhatsApp: +34 671 295 437',
      },
    ],
    updated: 'מדיניות זו עודכנה לאחרונה: אפריל 2026',
  } : {
    title: 'Privacy Policy',
    subtitle: 'In accordance with Israeli Privacy Protection Law, 5741-1981 (Amendment 13)',
    sections: [
      {
        heading: '1. General',
        text: 'This privacy policy describes how Eran MH Coaching ("we", "the website") collects, uses, and protects personal information provided by you ("the user"). This policy is updated in accordance with Amendment 13 to the Israeli Privacy Protection Law, effective August 14, 2025.',
      },
      {
        heading: '2. Information We Collect',
        text: 'Through your use of the website, we may collect:\n• Full name\n• Phone number\n• Country of residence\n• Preferred contact time (morning/noon/evening)\n• Email address (if provided)\n• Free-text message content (if provided)\n• Website usage data via cookies',
      },
      {
        heading: '3. Purposes of Data Collection',
        text: 'Information is collected solely for:\n• Follow-up contact per your inquiry\n• Providing information about coaching services\n• Scheduling meetings and introductory calls\n• Improving user experience\n\nNo marketing use without your explicit consent.',
      },
      {
        heading: '4. Legal Basis for Processing',
        text: 'Processing is based on your explicit consent given when submitting the contact form and accepting this privacy policy. You may withdraw consent at any time.',
      },
      {
        heading: '5. Data Storage & Security',
        text: 'Data is stored in secure systems including:\n• SSL/TLS encrypted traffic\n• Access restricted to authorized personnel only\n• Secure cloud storage\n\nData is retained as long as needed for its purpose, or until you request deletion.',
      },
      {
        heading: '6. Third-Party Sharing',
        text: 'We do not sell or rent personal data. Data may be shared only:\n• When required by law\n• For service provision (e.g., email delivery services)\n\nAll transfers are subject to appropriate safeguards.',
      },
      {
        heading: '7. Your Rights',
        text: 'Under Amendment 13, you have the right to:\n• Access your stored personal data\n• Correct inaccurate information\n• Request data deletion\n• Restrict processing\n• Withdraw consent\n\nContact: eran.mazor86@gmail.com. We will respond within 30 days.',
      },
      {
        heading: '8. Cookies',
        text: 'We use cookies for:\n• Language preferences\n• Browsing experience improvement\n• Statistical analysis\n\nManage preferences via the cookie banner or browser settings.',
      },
      {
        heading: '9. Database Registration',
        text: 'Per Amendment 13, this website is not required to register a database, as its primary purpose is not collecting data for transfer to others as a business, and it does not hold data on more than 10,000 individuals.',
      },
      {
        heading: '10. Contact',
        text: 'For questions or exercising your rights:\nEmail: eran.mazor86@gmail.com\nWhatsApp: +34 671 295 437',
      },
    ],
    updated: 'This policy was last updated: April 2026',
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      onClick={onClose}
      data-testid="privacy-modal-overlay"
    >
      <div 
        className="bg-white rounded-3xl max-w-2xl w-full max-h-[85vh] overflow-y-auto p-8 md:p-10 relative"
        onClick={(e) => e.stopPropagation()}
        dir={language === 'he' ? 'rtl' : 'ltr'}
        data-testid="privacy-modal"
      >
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 transition-colors"
          data-testid="privacy-close"
        >
          <X size={20} />
        </button>

        <div className="flex items-center gap-3 mb-2">
          <Shield size={24} style={{ color: 'var(--sage-600)' }} />
          <h2 
            className="text-2xl md:text-3xl"
            style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--charcoal)' }}
          >
            {content.title}
          </h2>
        </div>
        <p className="text-sm text-gray-500 mb-6">{content.subtitle}</p>

        <div className="space-y-5">
          {content.sections.map((section, i) => (
            <div key={i}>
              <h3 className="font-medium mb-2" style={{ color: 'var(--charcoal)' }}>
                {section.heading}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm whitespace-pre-line">{section.text}</p>
            </div>
          ))}
        </div>

        <p className="text-gray-400 text-xs mt-8">{content.updated}</p>
      </div>
    </div>
  );
};

export default PrivacyModal;
